module.exports = __webpack_public_path__ + "static/img/game_left01.46b456e5.png";